<div class="win">
    <div class="main">
        <h1>Registration is Closed</h1>
        <p>You can no longer participate in this competition. The registration deadline was {{ endDate | utcToCompTime: 'fullDateTime' }}.</p>
        <a href="{{feSite}}/timeline" target="_blank">View timeline</a>
    </div>
</div>
  